"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.germanTranslations = void 0;
var _types = require("../../../types");
const germanTranslations = exports.germanTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Es tut uns leid!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Zurück',
  [_types.ErrorPageTranslationKey.text]: 'Diese Seite ist im Moment außer Betrieb',
  [_types.ErrorPageTranslationKey.notFound]: 'Seite nicht gefunden.',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Die Seite, die Sie zu erreichen versuchen, ist eingeschränkt und nicht alle Kriterien wurden erfüllt.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Bitte kontaktieren Sie das Oriflame-Supportteam per E-Mail:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Die angeforderte URL wurde abgelehnt!'
};
